module.exports = __webpack_public_path__ + "img/gsb.6e83ede3.svg";